/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePccPatientResponse
 */
export interface CreatePccPatientResponse {
    /**
     * 
     */
    pending_patient_id: string;
}

/**
 * Check if a given object implements the CreatePccPatientResponse interface.
 */
export function instanceOfCreatePccPatientResponse(value: object): value is CreatePccPatientResponse {
    if (!('pending_patient_id' in value) || value['pending_patient_id'] === undefined) return false;
    return true;
}

export function CreatePccPatientResponseFromJSON(json: any): CreatePccPatientResponse {
    return CreatePccPatientResponseFromJSONTyped(json, false);
}

export function CreatePccPatientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccPatientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pending_patient_id': json['pending_patient_id'],
    };
}

export function CreatePccPatientResponseToJSON(json: any): CreatePccPatientResponse {
    return CreatePccPatientResponseToJSONTyped(json, false);
}

export function CreatePccPatientResponseToJSONTyped(value?: CreatePccPatientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pending_patient_id': value['pending_patient_id'],
    };
}

